import { combineReducers } from 'redux'
import account from './account'
import accounts from './accounts'
import globalConfig from './globalConfig'
import processing from './processing'

const fundsDistribution = combineReducers({
  account,
  accounts,
  globalConfig,
  processing,
})

export default fundsDistribution
